import { ErrorOverlay } from "@/components/overlay/error";

import { FC, useEffect, useState } from "react";
import { Outlet } from "react-router";
import { LoadingOverlay } from "@/components/overlay/loading";
import { useAtlasAuthContext, AuthContextType } from "@/contexts/atlas-auth";

interface OutletLoadingHandlers {
  setIsReady: () => void;
  setIsError: () => void;
}

export const AtlasStoreProviderOutlet: FC = () => {
  const [showLoadingOverlay, setShowLoadingOverlay] = useState(true);
  const [showErrorOverlay, setShowErrorOverlay] = useState(false);

  const setIsReady = () => setShowLoadingOverlay(false);
  const setIsError = () => setShowErrorOverlay(true);

  const { authContext } = useAtlasAuthContext();

  return (
    <>
      <ErrorOverlay isVisible={showErrorOverlay} />
      <LoadingOverlay isVisible={showLoadingOverlay} />
      <StoreProviderOutlet
        authContext={authContext}
        setIsReady={setIsReady}
        setIsError={setIsError}
      />
    </>
  );
};

const StoreProviderOutlet: FC<{ authContext: AuthContextType } & OutletLoadingHandlers> = ({
  authContext,
  setIsReady,
}) => {
  /**
   * We do this in a useEffect to trigger the animations.
   */
  useEffect(() => {
    if (authContext.isAuthenticated) {
      setIsReady();
    }
  }, [authContext.isAuthenticated]);

  if (authContext.isLoading) {
    return;
  }

  return <Outlet />;
};
